import styled, { keyframes } from "styled-components";

import { Colors } from "@swegon/sds-core";

const slideIn = keyframes`
    from {
        opacity: 0;
        transform: translateY(-8px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const pulse = keyframes`
    0% {
        box-shadow: 0 0 0 0 ${Colors.swegonGreen50};
    }
    70% {
        box-shadow: 0 0 0 8px transparent;
    }
    100% {
        box-shadow: 0 0 0 0 transparent;
    }
`;

export const ReleaseButton = styled.button`
    align-items: center;
    animation: ${slideIn} 300ms ease-out;
    appearance: none;
    background: ${Colors.swegonGreen10};
    border: 1px solid ${Colors.swegonGreen50};
    border-left: 4px solid ${Colors.swegonGreen};
    border-radius: 4px;
    color: ${Colors.grey};
    cursor: pointer;
    display: inline-flex;
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    gap: 10px;
    margin-left: 16px;
    padding: 7px 12px;
    text-align: left;
    transition: background 150ms ease-out, border-color 150ms ease-out;
    white-space: nowrap;

    &:hover,
    &:focus-visible {
        background: ${Colors.swegonGreen25};
        border-color: ${Colors.swegonGreen};
        outline: none;
    }

    &:disabled {
        background: ${Colors.grey2};
        border-color: ${Colors.grey25};
        border-left-color: ${Colors.uGrey50};
        color: ${Colors.grey75};
        cursor: default;
    }
`;

export const Indicator = styled.span`
    animation: ${pulse} 2s ease-out infinite;
    background: ${Colors.swegonGreen};
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
    height: 10px;
    width: 10px;

    ${ReleaseButton}:disabled & {
        animation: none;
        background: ${Colors.uGrey50};
    }
`;

export const ReloadIcon = styled.svg`
    flex-shrink: 0;
    height: 16px;
    width: 16px;
`;
